import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: "2%",
        margin: "2%"
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    }
});

const MobileProductEditForm = props => {
    const { classes, formSettings, editable, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(true);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                name="OperatingSystem"
                                value={values.OperatingSystem}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OperatingSystem && touched.OperatingSystem)}
                                placeholder={translations['operating_system'] || 'Operating system'}
                                label={translations['operating_system'] || 'Operating system'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="OperatingSystemVersionPreProcessing"
                                value={values.OperatingSystemVersionPreProcessing}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OperatingSystemVersionPreProcessing && touched.OperatingSystemVersionPreProcessing)}
                                placeholder={translations['operating_system_version_pre_processing'] || 'Pre processing operating system version'}
                                label={translations['operating_system_version_pre_processing'] || 'Pre processing operating system version'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="OperatingSystemVersion"
                                value={values.OperatingSystemVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OperatingSystemVersion && touched.OperatingSystemVersion)}
                                placeholder={translations['operating_system_version'] || 'Operating system version'}
                                label={translations['operating_system_version'] || 'Operating system version'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ScreenSize"
                                value={values.ScreenSize}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ScreenSize && touched.ScreenSize)}
                                placeholder={translations['screen_size'] || 'Screen size'}
                                label={translations['screen_size'] || 'Screen size'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="CPUArchitecture"
                                value={values.CPUArchitecture}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.CPUArchitecture && touched.CPUArchitecture)}
                                placeholder={translations['cpu_architecture'] || 'CPU Architecture'}
                                label={translations['cpu_architecture'] || 'CPU Architecture'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ApiLevel"
                                value={values.ApiLevel}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ApiLevel && touched.ApiLevel)}
                                placeholder={translations['api_level'] || 'API Level'}
                                label={translations['api_level'] || 'API Level'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Processor"
                                value={values.Processor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Processor && touched.Processor)}
                                placeholder={translations['processor'] || 'Processor'}
                                label={translations['processor'] || 'Processor'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="BuiltDate"
                                value={values.BuiltDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.BuiltDate && touched.BuiltDate)}
                                placeholder={translations['built_date'] || 'Built date'}
                                label={translations['built_date'] || 'Built date'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ManufactoryDate"
                                value={values.ManufactoryDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ManufactoryDate && touched.ManufactoryDate)}
                                placeholder={translations['manufactury_date'] || 'Manufactury Date'}
                                label={translations['manufactury_date'] || 'Manufactury Date'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="DeviceColor"
                                value={values.DeviceColor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.DeviceColor && touched.DeviceColor)}
                                placeholder={translations['device_color'] || 'Device color'}
                                label={translations['device_color'] || 'Device color'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="NetworkStandard"
                                value={values.NetworkStandard}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.NetworkStandard && touched.NetworkStandard)}
                                placeholder={translations['network_standard'] || 'Network standard'}
                                label={translations['network_standard'] || 'Network standard'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ProductIdentifier"
                                value={values.ProductIdentifier}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ProductIdentifier && touched.ProductIdentifier)}
                                placeholder={translations['product_identifier'] || 'Product identifier'}
                                label={translations['product_identifier'] || 'Product identifier'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ProductVersion"
                                value={values.ProductVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ProductVersion && touched.ProductVersion)}
                                placeholder={translations['product_version'] || 'Product version'}
                                label={translations['product_version'] || 'Product version'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="AvailableSimCardSlots"
                                value={values.AvailableSimCardSlots}
                                onChange={handleChange}
                                type={'number'}
                                onBlur={handleBlur}
                                error={!!(errors.AvailableSimCardSlots && touched.AvailableSimCardSlots)}
                                placeholder={translations['available_sim_card_slots'] || 'Available SIM card slots'}
                                label={translations['available_sim_card_slots'] || 'Available SIM card slots'}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="InstalledSimCards"
                                value={values.InstalledSimCards}
                                onChange={handleChange}
                                type={'number'}
                                onBlur={handleBlur}
                                error={!!(errors.InstalledSimCards && touched.InstalledSimCards)}
                                placeholder={translations['installed_sim_card'] || 'Installed SIM cards'}
                                label={translations['installed_sim_card'] || 'Installed SIM cards'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SdCardAmount"
                                type={'number'}
                                value={values.SdCardAmount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SdCardAmount && touched.SdCardAmount)}
                                placeholder={translations['sd_card_amount'] || 'SD card amount'}
                                label={translations['sd_card_amount'] || 'SD card amount'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ANumber"
                                value={values.ANumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ANumber && touched.ANumber)}
                                placeholder={translations['a_number'] || 'ANumber'}
                                label={translations['a_number'] || 'ANumber'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="OemStatus"
                                value={values.OemStatus}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OemStatus && touched.OemStatus)}
                                placeholder={translations['oem_status'] || 'Oem status'}
                                label={translations['oem_status'] || 'Oem status'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="OemReason"
                                value={values.OemReason}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OemReason && touched.OemReason)}
                                placeholder={translations['oem_reason'] || 'Oem reason'}
                                label={translations['oem_reason'] || 'Oem reason'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["is_rooted"] || "Rooted"}</InputLabel>
                                <Select
                                    name="IsRooted"
                                    label={translations["is_rooted"] || "Rooted"}
                                    margin={"dense"}
                                    value={values.IsRooted?.toString() || '-1'}
                                    onChange={handleChange}
                                >
                                    <MenuItem key={"yes"} value={"-1"}>
                                        {translations['short_not_assigned'] || 'n/a'}
                                    </MenuItem>
                                    <MenuItem key={"yes"} value={"0"}>
                                        {translations['no'] || 'No'}
                                    </MenuItem>
                                    <MenuItem key={"yes"} value={"1"}>
                                        {translations['yes'] || 'Yes'}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                name="ECID"
                                value={values.ECID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ECID && touched.ECID)}
                                placeholder={'ECID'}
                                label={'ECID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="MEID"
                                value={values.MEID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MEID && touched.MEID)}
                                placeholder={'MEID'}
                                label={'MEID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SecurazeVersion"
                                value={values.SecurazeVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SecurazeVersion && touched.SecurazeVersion)}
                                placeholder={translations['securaze_version'] || 'Securaze version'}
                                label={translations['securaze_version'] || 'Securaze version'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled
                            />
                            <TextField
                                name="HardwareID"
                                value={values.HardwareID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.HardwareID && touched.HardwareID)}
                                placeholder={translations['hardware_id'] || 'HardwareID'}
                                label={translations['hardware_id'] || 'HardwareID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    style={{ width: '100%' }}
                                    type="submit"
                                    disabled={!(isValid && dirty) || isSubmitting || !editable}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(MobileProductEditForm);
